export default __webpack_public_path__ + "1fd3ed0d6a3254285a8bd898e46c07a2.png";